<template>
    <div class="main">
        <img class="avatar" src="~@/assets/avatar.png" alt="avatar"/>
        <p class="name">-Mohammad Shams-</p>
        <p class="desc">Game Developer - Programmer</p>
        <div class="icons-box">
            <a href="http://shamsdev.com/files/Shams-CV.pdf" target="_blank">
                <img class="icon" src="~@/assets/cv.png" alt="cv"/>
            </a>

            <a href="https://www.linkedin.com/in/mohammad-shams-68565b127" target="_blank">
                <img class="icon" src="~@/assets/in.png" alt="linkedin"/>
            </a>

            <a href="https://github.com/shamsdev" target="_blank">
                <img class="icon" src="~@/assets/github.png" alt="github"/>
            </a>

            <a href="mailto:imshamsdev@gmail.com" target="_blank">
                <img class="icon" src="~@/assets/email.png" alt="github"/>
            </a>
        </div>
    </div>
</template>

<script>
    export default {
        name: "MainComponent"
    }
</script>

<style>

    .avatar {
        width: 180px;
        border-radius: 50%;
        box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.1), 0 6px 20px 0 rgba(0, 0, 0, 0.09);
        user-select: none;
        -webkit-user-drag: none;
    }

    .icon {
        width: 24px;
        margin: 5px;
        user-select: none;
        -webkit-user-drag: none;
        transition-duration: 0.3s;
    }


    .icon:hover {
        opacity: 0.4;
    }

    .icons-box {
        margin-top: 16px;
    }

    .name {
        margin-top: 8px;
        color: white;
        font-size: 23px;
        user-select: none;
    }


    .desc {
        font-size: 15px;
        color: #646f8a;
        user-select: none;
    }

    @media screen and (max-width: 600px) {
        .avatar {
            width: 150px;
        }

        .icon {
            width: 20px;
        }


        .name {
            font-size: 18px;
        }

        .desc {
            font-size: 12px;
        }
    }

</style>
